"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { WowActionButton } from "@/components/wow/action-button";
import { WowSpellTooltip } from "@/components/wow/spell-tooltip";
import { WOW_ICONS } from "@/components/wow/wow-icons";
import { useWowMode } from "@/components/wow/wow-mode";

/** Floating hearthstone in the corner — the way back to the mundane UI. */
export function WowHearthstone() {
  const { active, setActive } = useWowMode();

  if (!active) return null;

  return (
    <div className="fixed right-5 bottom-5 z-50">
      <Tooltip>
        <TooltipTrigger
          render={
            <WowActionButton
              icon={WOW_ICONS.hearthstone}
              label="Hearthstone — return to the normal interface"
              className="wow-hearthstone size-12!"
              onClick={() => setActive(false)}
            />
          }
        />
        <TooltipContent
          side="left"
          className="wow-spell-tooltip bg-transparent p-0"
        >
          <WowSpellTooltip
            name="Hearthstone"
            cost="None"
            castTime="Instant"
            description="Returns you to the standard interface."
          />
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
